// https://swiperjs.com/get-started
import SwiperCore, { Navigation, Pagination, Scrollbar } from 'swiper/core';
SwiperCore.use([Navigation, Pagination, Scrollbar]);
import 'swiper/swiper-bundle.css';

const swiper = new SwiperCore('.standard--slider', {
    // Optional parameters
    direction: 'horizontal',
    loop: true,

    // If we need pagination
    pagination: {
        el: '.swiper-pagination',
        clickable: true
    },

    // Navigation arrows
    navigation: {
        nextEl: '.swiper--next',
        prevEl: '.swiper--prev',
    },

    // And if we need scrollbar
    scrollbar: {
        el: '.swiper-scrollbar',
    },
});

document.querySelectorAll('.timeline--slider').forEach((sliderEl) => {
    const slideCount = sliderEl.querySelectorAll('.swiper-slide').length;
    const config = {
        direction: 'horizontal',
        loop: slideCount > 1,
    };

    if (slideCount > 1) {
        config.navigation = {
            nextEl: sliderEl.querySelector('.swiper--next'),
            prevEl: sliderEl.querySelector('.swiper--prev'),
        };
    }

    new SwiperCore(sliderEl, config);
});

const swiperDienstleistungen = new SwiperCore('.dienstleistungen--slider', {
    // Optional parameters
    direction: 'horizontal',
    loop: true,
    slidesPerView: 1,
    spaceBetween: 50,
    // Navigation arrows
    navigation: {
        nextEl: '.swiper--next',
        prevEl: '.swiper--prev',
    },
    breakpoints: {
        // when window width is >= 640px
        768: {
            slidesPerView: 2,
            spaceBetween: 40
        },
        1024: {
            slidesPerView: 3,
            spaceBetween: 40
        }
      }
});
